import React, {useEffect, useState} from "react";
import {TopRightNav} from "../cmp/header/TopRightNav";
import {useUnitsState} from "../store/UnitsState";
import {useParams} from "react-router";
import {IObject} from "../interfaces/IObject";
import {BreadCrumbs} from "../cmp/header/BreadCrumbs";

export function PageObjectMap() {

  const store = useUnitsState()
  let params = useParams<{ object_name: string }>();
  let [object, setObject] = useState<IObject | undefined>(undefined);

  useEffect(() => {
    if (store.loading) return
    if (params.object_name) {
      object = store.objects.find(o => o.name === params.object_name)
      if(object) {
        setObject(object)
        // store.setSelectedObject(object)
      }
    }
  }, [store.loading])

  if (store.loading || !object) {
    return null
  }

  return <div id="app-storefront-floor">
    <header>
      <section>
        <BreadCrumbs object={object} />
        <div data-component="TopRightNav"><TopRightNav/></div>
      </section>
    </header>
  </div>
}